import '../_rollupPluginBabelHelpers-1f0bf8c2.js';
import 'react';
import 'reakit-utils/useIsomorphicEffect';
import { useSealedState } from 'reakit-utils/useSealedState';
import '../reverse-30eaa122.js';
import '../getCurrentId-5aa9849e.js';
import '../findEnabledItemById-8ddca752.js';
import '../Id/IdProvider.js';
import 'reakit-utils/applyState';
import '../Id/IdState.js';
import { useCompositeState } from '../Composite/CompositeState.js';

function unstable_useGridState(initialState) {
  if (initialState === void 0) {
    initialState = {};
  }

  var sealed = useSealedState(initialState);
  return useCompositeState(sealed);
}

export { unstable_useGridState };
